import { auth, type SchemaResponse } from "@/modules/api"
import { ECheckKolSubmissionStatus } from "@/modules/helpers/enum"
import type { SubmissionCampaign } from "@/modules/types"
import type { PagingSchema } from "@/modules/types/common/schema"

export const getSubmissionList = ({
  page,
  take = 10,
  ...params
}: {
  page: number
  take?: number
  [key: string]: any
}) => {
  return auth.get<SchemaResponse<PagingSchema<SubmissionCampaign>>>("kol-submissions/list", {
    params: {
      page,
      take,
      ...params
    }
  })
}

export const fetchSubmissionDetails = (id: string) => {
  return auth.get<SchemaResponse<SubmissionCampaign>>(`kol-submissions/${id}`)
}

export const checkStatusSubmission = (id: string) => {
  return auth.get<SchemaResponse<ECheckKolSubmissionStatus[]>>(
    `/kol-submissions/check-status/${id}`
  )
}

export const rejectInvitedReceiveSample = (kolSubmissionId: string) => {
  return auth.post(`/kol-submissions/reject-invited-receive-sample/${kolSubmissionId}`)
}

export type RefreshSampleApplicationResponse = {
  error: boolean
  data: boolean
  message: string
  code: number
}

export const refreshSampleApplication = (kolSubmissionId: string) => {
  return auth.post<RefreshSampleApplicationResponse>(
    `v1/kol-submissions/${kolSubmissionId}/sample-application/refresh`
  )
}
